import React from 'react';

// Native <select> styled to match the app's inputs.
// h-12 is gone on purpose: it was a hardcoded 48px that outranked min-h-input,
// so the select stayed tall after the control token moved to 36px and sat
// visibly out of line with every button beside it.
const selectClasses = 'box-border min-h-input w-full cursor-pointer rounded-input border border-mid bg-page px-2.5 font-sans text-[13px] text-fg-1 placeholder:capitalize focus-visible:border-primary/50 focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:outline-none disabled:cursor-not-allowed disabled:appearance-none disabled:bg-page-alt disabled:text-fg-3';

export interface SelectProps {
  id?: string;
  className?: string;
  placeholder?: string;
  value?: string;
  defaultValue?: string;
  options: { value: any, label: string, disabled?: boolean }[];
  onChange?(value: string, e: React.ChangeEvent<HTMLSelectElement>): void;
  disabled?: boolean;
}

export const Select = (props: SelectProps) => {
  return (
    <select
      id={props.id}
      className={`${selectClasses}${props.className ? ` ${props.className}` : ''}`}
      value={props.value}
      defaultValue={props.defaultValue}
      onChange={(e) => props.onChange?.(e.target.value, e)}
      disabled={props.disabled}
    >
      {
        props.options.map((option) => {
          return (
            <option key={option.value} value={option.value} disabled={option.disabled}>{option.label}</option>
          );
        })
      }
    </select>
  );
};